"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncSimpleSlice = asyncSimpleSlice;
exports.asyncSlice = asyncSlice;
exports.default = void 0;

var _circularBuffer = require("../../internal/circular-buffer");

var _asyncIterable = require("../../internal/async-iterable");

async function bufferedSlice(source, start, end, step) {
  const bufferSize = Math.abs(start);
  const buffer = new _circularBuffer.CircularBuffer(bufferSize);
  let counter = 0;

  for await (const item of source) {
    buffer.push(item);
    counter++;
  }

  let newEnd;

  if (isFinite(end) && end > 0) {
    newEnd = end - (counter - bufferSize);
    if (newEnd < 0) return [];
  } else {
    newEnd = end;
  }

  return asyncSimpleSlice(buffer, 0, newEnd, step);
}

async function* asyncSimpleSlice(source, start, end, step = 1) {
  let currentPos = 0;
  let nextValidPos = start;
  const bufferSize = Math.abs(end);
  let buffer;
  let counter = 0;

  if (end < 0) {
    buffer = new _circularBuffer.CircularBuffer(bufferSize);
  }

  for await (let item of source) {
    if (buffer) {
      item = buffer.push(item);
      counter++;

      if (counter <= bufferSize) {
        continue;
      }
    }

    if (currentPos >= end && end >= 0) {
      break;
    }

    if (nextValidPos === currentPos) {
      yield item;
      nextValidPos += step;
    }

    currentPos++;
  }
}

async function* asyncSlice(source, start, end, step = 1) {
  if (start >= 0) {
    yield* asyncSimpleSlice(source, start, end, step);
  } else {
    yield* await bufferedSlice(source, start, end, step);
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncSlice, {
  validateArgs(args) {
    let [optsOrStart = 0, end = Infinity, step = 1] = args;
    let start = typeof optsOrStart === 'number' ? optsOrStart : undefined;

    if (optsOrStart && typeof optsOrStart === 'object') {
      ({
        start = 0,
        end = Infinity,
        step = 1
      } = optsOrStart);
    }

    if (typeof start !== 'number') {
      throw new TypeError('The specified start was not a number');
    }

    if (typeof end !== 'number') {
      throw new TypeError('The specified end was not a number');
    }

    if (typeof step !== 'number' || step <= 0) {
      throw new TypeError('The specified step was not a number > 0');
    }

    args[0] = start;
    args[1] = end;
    args[2] = step;
  },

  optionalArgsAtEnd: true,
  minArgs: 0,
  maxArgs: 3
});

exports.default = _default;